import React, { useState, useEffect } from 'react';
import '../styles/Whitepaper.css';

function Whitepaper() {
  const [isProtected, setIsProtected] = useState(true);

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    const handleKeyDown = (e) => {
      if (e.ctrlKey || e.metaKey) {
        if (e.keyCode === 83 || e.keyCode === 67) {
          e.preventDefault();
          return false;
        }
      }
    };

    if (isProtected) {
      document.addEventListener('contextmenu', handleContextMenu);
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isProtected]);

  return (
    <div className="whitepaper-container">
      <div className="whitepaper-header">
        <h2 style={{ color: 'dimgray' }}>Console One</h2>
        <h3>The Self-Evolving, Plug-and-Play SDLC Platform</h3>
      </div>

<div className="whitepaper-content">
        <h4>Overview</h4>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla facilisi. Proin nec purus eget sapien aliquet lacinia non et nulla. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla facilisi. Proin nec purus eget sapien aliquet lacinia non et nulla.</p>

        <h4>The Innovation</h4>
        <p>Integer at augue vitae velit ultrices cursus. Sed dapibus ipsum vitae nisl tincidunt, at interdum neque tincidunt. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla facilisi. Proin nec purus eget sapien aliquet lacinia non et nulla.</p>

        <h4>How It Works</h4>
        <ul>
          <li>Aliquam erat volutpat. Donec ut diam efficitur, convallis lorem eget, efficitur nunc.</li>
          <li>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae.</li>
          <li>Phasellus fermentum metus nec mi tempus, nec pharetra nisl scelerisque.</li>
        </ul>

        <h4>Why It Matters</h4>
        <p>Fusce id felis eu metus tincidunt tristique vel in justo. Quisque at lorem vel magna tincidunt posuere.</p>

        <h4>Conclusion</h4>
        <p>Maecenas tincidunt, eros vel convallis euismod, nunc nunc consequat sapien, vel pellentesque magna felis ut metus. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla facilisi. Proin nec purus eget sapien aliquet lacinia non et nulla.</p>
        {isProtected && <div className="whitepaper-overlay" />}
      </div>
    </div>
  );
}

export default Whitepaper;
